import { BrandLogo } from "@/shared/components/BrandLogo";

export function ExtLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-background text-foreground">
      <header className="px-8 py-5">
        <BrandLogo className="h-7 xs:h-8" />
      </header>

      <main className="flex flex-1 flex-col gap-3 px-8 py-20 xs:py-28 lg:pl-60">
        <div className="flex w-full max-w-[400px] flex-col gap-3 xs:w-fit xs:min-w-[400px]">
          {children}
        </div>
      </main>
    </div>
  );
}
